<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause" id="clause" ref="scrollDom">
        <div>
          <div style="-aw-headerfooter-type:header-primary">
          </div>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-align:center; line-height:22pt; widows:0; orphans:0"
          >
            <span style=" font-size:21pt; font-weight:bold"
              >企业信息查询及使用授权书</span
            >
          </p>
          <p style="margin-top:0pt; margin-bottom:0pt; line-height:22pt; widows:0; orphans:0">
            <span style=" font-size:11pt; font-weight:bold">尊敬的客户：</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:22pt; line-height:22pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >请确认您有权代表贵单位作出企业金融信息使用授权。如未经贵单位充分授权，您无权签
              署本授权书。为了保障贵单位的合法权益，在您确认签署本授权书之前，请您务必仔细阅读本授权书的所有条款，尤其加粗部分条款，并请您充分理解条款内容，如您对本授权书有任何异议或者疑问，请立即停止后续确认签署行为并及时与客服联系。如您不接受本授权书的任何条款，请您拒绝签署。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:22pt; line-height:22pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >吉林亿联银行股份有限公司投诉咨询热线：95396</span
            >
          </p>
          <p style="margin-top:0pt; margin-bottom:0pt; line-height:20pt; widows:0; orphans:0">
            <span style=" font-size:11pt"
              >吉林亿联银行股份有限公司（以下简称：被授权人）:</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:22pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">本企业充分理解并同意，鉴于授权人</span
            ><span style=" font-size:11pt; text-decoration:underline"
              >【 】【统一社会信用代码 ： 】</span
            ><span style=" font-size:11pt"
              >或涉及授权人的法定代表人/股东向被授权人申请贷款服务，为客观、准确地评估本企业的信用等级和授信额度，并为本企业提供优质的服务，就使用本企业的相关必要信息，本企业同意并授权如下：</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold">一、</span
            ><span style=" font-size:11pt">本企业同意并授权</span
            ><span style=" font-size:11pt; font-weight:bold">：</span
            ><span style=" font-size:11pt"
              >被授权人在办理以下涉及到本企业的业务时，为信用评估、风险控制、逾期账款催收等与《借款额度合同》、《借款合同》等（以实际名称为准）履行相关的目的，可以向中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司等依法设立的征信机构或信用服务机构查询、使用本人的信用信息和信用报告；收集在本人申请或使用授权业务过程中及还款期内，向被授权人提交的信息或新产生的信息；为了防范风险等合法目的，向合法留存本人信息的其他方（如被授权人的合作伙伴等，具体合作伙伴范围等以被授权人网站/APP或其他公开渠道公布的名单为准）收集或核验与授权业务相关的必要信息；向中国互联网金融协会、中国支付清算协会、公安部公民身份信息数据库、国际企业信用信息公示系统、法院公开信息平台、税务等部分政府机构、司法机关、公共事业单位、行业组织等第三方权威机构采集与授权业务相关的必要信息。上述信息采集方式包括但不限于查询、核实、采集、整理、打印、保存、加工和使用等符合法律法规规定的方式；上述本企业基本信息、信用信息和信用报告等包括但不限于名称、住所、经营范围、可证明依法设立或者可依法开展经营、社会活动的执照、证件或者文件的名称、号码和有效期限，行业、国籍、法定代表人或负责人和授权办理业务人员的姓名、身份证件或其他身份证明文件的种类、号码和有效期限，受益所有人的姓名、地址、身份证件或其他身份证明文件的种类、号码和有效期限，企业的联系地址、电子邮箱、工商信息、交易真实性、财务信息、税务信息、诉讼信息、执行信息、行政处罚信息和违法犯罪信息、互联网使用信息、互联网使用行为、银行账户真实性校验、设备信息、信用分析和信用评估结果、逾期及违约信息、授信及负债信息、对外担保信息、信贷交易记录、征信查询记录、失信被执行人信息、信用黑名单信息等企业信息、经营信息、征信信息、信用信息及各类不良信息。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">二、本企业同意并授权：</span
            ><span style=" font-size:11pt; font-weight:bold">被授权人可以向</span
            ><span style=" font-size:11pt"
              >中国人民银行金融信用信息基础数据库、百行征信有限公司、朴道征信有限公司等</span
            ><span style=" font-size:11pt; font-weight:bold"
              >依法设立的征信机构或信用服务机构提供本企业的基础信息（包括但不限于本企业的基本信息、借贷信息、履约风险信息、担保信息）和信贷业务交易等相关信用信息（包括但不限于本企业因未及时履行合同义务产生的不良信息）。本企业知悉，被授权人向征信机构提供本企业相关信息为其履行《征信业管理条例》第二十九条（即</span
            ><span style=" font-size:11pt; font-weight:bold">“</span
            ><span style=" font-size:11pt; font-weight:bold"
              >向金融信用信息基础数据库提供信贷信息</span
            ><span style=" font-size:11pt; font-weight:bold">”</span
            ><span style=" font-size:11pt; font-weight:bold"
              >）规定的义务所必须。且本企业知悉，信用记录、信用报告或信用评分是国家机关、其他个人和机构对信用进行依法查询和/或提供服务或进行限制的参考依据，本企业已经理解并知悉提供该等信息可能会对本企业产生的影响。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt"
              >三、本企业同意并授权：被授权人可收集、存储、使用、分析本企业在注册、使用服务时，在被授权人的</span
            ><span style=" font-size:11pt; font-weight:bold"
              >相关历史信息、支付数据信息和本企业注册、使用被授权人软件产品产生的相关必要信息</span
            ><span style=" font-size:11pt">等，包括但不限于所提供</span
            ><span style=" font-size:11pt; font-weight:bold"
              >的名称，证照号码、注册地址、联系地址、电子邮箱、工商信息、交易真实性、财务信息、税务信息、诉讼信息、执行信息、行政处罚信息和违法犯罪信息、互联网使用信息、互联网使用行为、银行账户真实性校验、设备信息、信用分析和信用评估结果、逾期及违约信息、授信及负债信息、对外担保信息、信贷交易记录、征信查询记录、失信被执行人信息、信用黑名单信息等企业信息、经营信息、征信信息、信用信息及各类不良信息。</span
            ><span style=" font-size:11pt"
              >本服务通过使用这些信息识别本企业的身份，以便遵守国家相关法律法规的规定，为本企业提供贷款服务。上述信息属于涉及企业敏感信息，如本企业拒绝提供上述信息，被授权人将无法为本企业提供信贷服务，但不影响其为本企业提供其他服务。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt"
              >四、本企业同意被授权人可将获取的上述信息用于：</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >1.核验授权人身份真实性，对授权人资信状况进行风险评估与管理；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >2.审核、审批、受理、办理授权人的贷款相关业务及授权人提供担保的贷款业务；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >3.在该业务存续期间检测本企业的信用变化，进行贷后服务和管理；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >4.涉及授权人法定代表人、经营者、关联人的信贷、担保或风险管理业务，需查询授权人信用信息及公司相关信息的；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >5.授权人申请征信异议处理；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >6.依法或经有权部门要求；</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >7.其他经过本企业同意的合法用途。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">五、本企业同意并授权：</span
            ><span style=" font-size:11pt; font-weight:bold"
              >为了维护被授权人的合法权益，在本企业逾期还款或者出现本企业与被授权人签署的合同、协议、承诺或其他法律文件项下的违约时，被授权人可将本企业的联系方式、联系地址及本企业违约信息等信息公开，并根据欠款催收、债权转让、金融外包等需要将有关信息提供给被授权人委托的催收机构、资产管理公司、外包公司等第三方使用，具体第三方范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人网站/APP或其他公开渠道公布的名单为准</span
            ><span style=" font-size:11pt">。</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">六、本企业同意并授权：</span
            ><span style=" font-size:11pt; font-weight:bold"
              >为便于向本企业提供更加优质的服务和产品，本企业授权被授权人可以将前述信息分享给与本企业在被授权人办理业务相关的被授权人合作伙伴，具体合作伙伴范围、联系方式、处理目的、处理方式和个人信息种类等以被授权人网站/APP或其他公开渠道公布的名单为准</span
            ><span style=" font-size:11pt">。</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.85pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">七、本企业知悉，</span
            ><span style=" font-size:11pt; font-weight:bold"
              >被授权人所获取的本企业信息保存期限为【5】年。若因本企业逾期还款等情形，被授权人于上述期限后仍有使用本企业信息之必要的，本企业同意并授权被授权人将本企业的信息保存至上述情形消灭之日起【5】年。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">八、</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本企业声明：本授权书是本企业向被授权人做出的单方承诺，且效力具有独立性，不因《借款额度合同》、《借款合同》等（以实际名称为准）的任何条款无效而失效。</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本授权书有效期自本授权书出具之日起至本企业或前述涉及到本企业在被授权人信贷业务终结之日止。如下情形视为本企业与被授权人的业务未终结：本企业在被授权人处有信贷余额或有授信额度；本企业提供担保的授信业务有信贷余额或有授信额度。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt">九、</span
            ><span style=" font-size:11pt; font-weight:bold"
              >若本企业信贷业务未获批准，</span
            ><span style=" font-size:11pt; font-weight:bold"
              >则本授权书自动失效，授权自动终止。同时，</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本企业同意被授权人自行删除本企业个人信息资料，无须退回本企业。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >十、本企业同意，因本企业个人信息为被授权人进行风险评估及贷后管理所必须，因此，若本企业撤回对被授权人的上述授权，则被授权人保留其停止发放贷款并要求授权人提前还贷的权利。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >十一、如果被授权人超出本授权书范围进行数据报送和查询使用，则被授权人应承担与此有关的法律责任。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >十二、若本企业与以上被授权人发生任何纠纷或争议，首先应友好协商解决；协商不成的，本企业同意将纠纷或争议提交本授权书签订地（即中国吉林省长春市南关区）有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt"
              >本企业声明：本企业同意本授权书以数据电文形式成立，自本人在线确认起即生效。</span
            ><span style=" font-size:11pt; font-weight:bold"
              >本企业已经仔细阅读上述条款，并特别注意黑体字的内容，被授权人已应本企业要求对相关条款予以明确说明。本企业对所有条款的含义及相应的法律后果已全部通晓并充分理解，本企业自愿作出上述授权、承诺和声明。</span
            >
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold">授权企业：</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold">法定代表人：</span>
          </p>
          <p
            style="margin-top:0pt; margin-bottom:0pt; text-indent:21.75pt; line-height:20pt; widows:0; orphans:0"
          >
            <span style=" font-size:11pt; font-weight:bold"
              >签署日期（授权书生效日期）：</span
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Button from '@/components/Button.vue';

export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {},
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 14px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 14px; */
}
p {
  margin-bottom: 8px;
  text-align: left;
}
li,
h2 {
  text-align: left;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 14px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
